// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2o6pQ","vLegacy":"SelectSecondary_vLegacy__1wbYB","error":"SelectSecondary_error__YEM8g","disabled":"SelectSecondary_disabled__1PleD"};